document.addEventListener("DOMContentLoaded", () => {
  // Function to format phone numbers
  const formatPhone = (input) => {
    if (!input) return;

    const handleChange = () => {
      let phone = input.value.trim();

      // Do nothing if empty or already has +961
      if (!phone || phone.startsWith("+961")) return;

      // Remove non-digits
      phone = phone.replace(/\D/g, "");

      // Remove leading 0 if present
      if (phone.startsWith("0")) phone = phone.substring(1);

      // Add +961 prefix
      input.value = `+961${phone}`;
    };

    input.removeEventListener("blur", handleChange);
    input.addEventListener("blur", handleChange);
  };

  // Function to continuously check for phone inputs (handles AJAX carts)
  const observePhoneInputs = () => {
    const observer = new MutationObserver(() => {
      document.querySelectorAll('input[type="tel"], input[name*="phone"]').forEach(formatPhone);
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Run immediately for any existing input
    document.querySelectorAll('input[type="tel"], input[name*="phone"]').forEach(formatPhone);
  };

  observePhoneInputs();
});
